import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "../datatable/DataTable";
import "./author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const authorEditPath = "edit-author";
const authorListEndpoint = ApiEndpoints.autor.authorList;
const authorDeleteEndpoint = ApiEndpoints.autor.authorDelete;
const tableHeader = ["Name", "Status"];
const tbody = ["name", "status"];

export default function AuthorListing() {

  const [data, setData] = useState([]);

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET", authorListEndpoint);
        const result = response.authors;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    dataFetch();
  }, []);

  const handleDelete = useCallback(
    async (author_id) => {
      const payload = { author_id };
      try {
        await ApiRequest("POST", authorDeleteEndpoint, payload);
        setData((prevData) => prevData.filter((item) => item._id !== author_id));
      } catch (error) {
        console.error("Error deleting author:", error);
      }
    },
    []
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Author</h5>
      </div>
      <div className="add-author-section">
        <Link className="default-btn" to="/admin/add-author">
          add author
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={authorEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
